<div class="d-flex justify-content-center flex-column align-items-center my-10 my-lg-20 px-5 px-lg-0">

  <img alt="Logo" [lazyLoad]="'/images/logos/logo-2.svg' | assetsImagekitUrlAppender" [useSrcset]="true" class="logo-default h-25px h-lg-50px mw-100" style="max-width: 400px;" />


  <div class="d-flex flex-column py-8 py-lg-12 text-center position-relative h-75" *ngIf="lottieOptions">
    <div class="d-flex justify-content-center">
      <ng-lottie class="top-0 z-index-3 w-250px" [options]="lottieOptions"></ng-lottie>
    </div>
  </div>


  <h1 class="text-center mt-10 mt-lg-20 text-black fs-2 fs-lg-1 px-5">
    {{message}}
  </h1>


  <a class="btn btn-theme text-white ls-2 text-uppercase fw-boldest my-10 my-lg-20 btn-lg" routerLink="/">
    Back to home
  </a>
</div>
